import Web3 from 'web3'
import ERC20_ABI from './data/ERC20_ABI';
import ERC721_ABI from './data/ERC721_ABI';

class EthereumWalletContext {
    constructor(address) {
        this.web3 = new Web3('https://mainnet.infura.io/v3/' + process.env.REACT_APP_INFURA_KEY);
        this.address = address;
        this.isValidAddr = this.web3.utils.isAddress.bind(this);
    }

    getABI(type) {
        if (type === "ERC721") {
            return ERC721_ABI;
        }
        if (type === "ERC20") {
            return ERC20_ABI;
        }
    }

    async queryToken(tokenType, tokenAddress) {
        console.log(tokenType);
        const contract = new this.web3.eth.Contract(this.getABI(tokenType), tokenAddress);
        contract.defaultAccount = this.address;
        const balance = await contract.methods.balanceOf(this.address).call();
        return balance;
    }

    setChain(chainId) {
        // only makes sense if we have access to Metamask and want to query for, say, an NFT on Arbitrum
    }

    async queryEth() {
        console.log(this);
        const balance = await this.web3.eth.getBalance(this.address);
        return Web3.utils.fromWei(balance);
    }
}

export default EthereumWalletContext;